import { calculateWorkerReliability } from "./workerMetrics";

export function buildWorkerMetricsFromShifts(workerUid, shifts = []) {
  const rows = (shifts || []).filter((s) => {
    const assigned =
      s.assignedWorkerUid ||
      (Array.isArray(s.assignedWorkerUids) ? s.assignedWorkerUids[0] : "");

    return String(assigned || "") === String(workerUid || "");
  });

  const completedShifts = rows.filter(
    (s) => String(s.status || "").toLowerCase() === "completed"
  ).length;

  const noShows = rows.filter(
    (s) => String(s.status || "").toLowerCase() === "no_show"
  ).length;

  const lateArrivals = rows.filter(
    (s) => s.arrivalLate === true || s.lateArrival === true
  ).length;

  const cancellations = rows.filter(
    (s) => String(s.status || "").toLowerCase() === "cancelled"
  ).length;

  const reliabilityScore = calculateWorkerReliability({
    completedShifts,
    noShows,
    lateArrivals,
    cancellations,
  });

  return {
    completedShifts,
    noShows,
    lateArrivals,
    cancellations,
    reliabilityScore,
  };
}